import React from 'react'
import { IconHandStop, IconMinus, IconPlus } from '@tabler/icons-react'

interface MapControlBarProps {
  zoomLevel: number
  onZoomIn?: () => void
  onZoomOut?: () => void
  onPanMode?: () => void
  isPanMode?: boolean
}

export const MapControlBar: React.FC<MapControlBarProps> = ({
  zoomLevel = 15,
  onZoomIn,
  onZoomOut,
  onPanMode,
  isPanMode = false,
}) => {
  return (
    <div className="flex items-center gap-2 rounded-full bg-[#27292C] p-2">
      <button
        className={`size-6 flex items-center justify-center rounded-full transition-colors ${
          isPanMode ? 'bg-orange-500' : 'bg-transparent'
        }`}
        onClick={onPanMode}
        aria-label="Toggle pan mode"
      >
        <div className="size-4 flex items-center justify-center p-1">
          <IconHandStop size={16} stroke={1.5} className="text-gray-50" />
        </div>
      </button>

      <div className="relative flex h-6 w-0 shrink-0 items-center justify-center">
        <div className="absolute h-6 w-px bg-gray-400"></div>
      </div>

      <button
        className="size-6 flex items-center justify-center rounded-full bg-transparent transition-colors hover:opacity-80"
        onClick={onZoomOut}
        aria-label="Zoom out"
      >
        <div className="size-4 flex items-center justify-center">
          <IconMinus size={16} stroke={1.5} className="text-gray-50" />
        </div>
      </button>

      <p className="shrink-0 font-['Inter',sans-serif] text-[14px] font-normal leading-[20px] text-gray-50">
        {zoomLevel}%
      </p>

      <button
        className="size-6 flex items-center justify-center rounded-full bg-transparent transition-colors hover:opacity-80"
        onClick={onZoomIn}
        aria-label="Zoom in"
      >
        <div className="size-4 flex items-center justify-center">
          <IconPlus size={16} stroke={1.5} className="text-gray-50" />
        </div>
      </button>
    </div>
  )
}
